import React from "react";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import GlassPointer from "./components/effects/GlassPointer";
import ScrollProgress from "./components/effects/ScrollProgress";
import Home from "./pages/Home";
import "./styles/globals.css";

const App = () => (
  <>
    {/* Fixed mesh background */}
    <div className="mesh-bg">
      <div className="mesh-orb mesh-orb--1" />
      <div className="mesh-orb mesh-orb--2" />
      <div className="mesh-orb mesh-orb--3" />
    </div>

    <ScrollProgress />
    <GlassPointer />

    <div className="content-wrap">
      <Navbar />
      <main>
        <Home />
      </main>
      <Footer />
    </div>
  </>
);

export default App;
